import { app } from '../app';

class ApplicationAccountsResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    setPasswordForAppAccount(companyId, appId, accId, password) {
        const url = `app/rest/v2/company/${companyId}/accounts/${appId}/${accId}/setpassword`;
        const params = {password};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    getPasswordForAppAccount(companyId, appId, accId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${appId}/${accId}/getpassword`;
        return this.$http.get(url).then(({data}) => data);
    }

    generatePasswordForAppAccount(companyId, appId, accId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${appId}/${accId}/generatepassword`;
        return this.$http.get(url, {transformResponse}).then(({data}) => data);

        // fixme: this is a workaround. response body should contain valid json.
        function transformResponse(data) {
            try {
                // response.data.message is available when the request fails
                return JSON.parse(data)
            } catch (e) {
                // success response is a bare string which cannot be parsed as json
                return data;
            }
        }
    }

    setPasswordResetEmailForAppAccount(companyId, appId, accId, email) {
        const url = `app/rest/v2/company/${companyId}/accounts/${appId}/${accId}/updatepwdresetemail`;
        const params = {email};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    sendPasswordResetEmailForAppAccount(companyId, appId, accId) {
        const url = `app/rest/v2/company/${companyId}/accounts/${appId}/${accId}/sendpwdresetemail`;
        return this.$http.get(url).then(({data}) => data);
    }
}

app.service('ApplicationAccountsResource', ApplicationAccountsResource);



// WEBPACK FOOTER //
// ./src/portal/rest/ApplicationAccountsResource.js